// extracted by mini-css-extract-plugin
export default {"box":"PopperUserInfo_box__HztEX","avatar":"PopperUserInfo_avatar__fV+ry","account-group":"PopperUserInfo_account-group__2KjNW"};